import { EnvironmentTermsPlacement } from '../enums';

export const EnvironmentTermsPlacements = [
  { name: 'Funds summary', value: EnvironmentTermsPlacement.FundSummary },
  { name: 'Funds detail', value: EnvironmentTermsPlacement.FundDetail },
  { name: 'Last page', value: EnvironmentTermsPlacement.LastPage },
  { name: 'Footer', value: EnvironmentTermsPlacement.Footer },
];
